"use client";
// Client Component: Next.js requires error boundaries to be client.

import { useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Unhandled error boundary hit:", error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-2xl font-semibold">Something went wrong.</h1>
      <p className="text-muted-foreground max-w-md text-sm">
        An unexpected error occurred. Try again, or report the digest below if
        the problem persists.
      </p>
      {error.digest ? (
        <code className="text-muted-foreground text-xs">{error.digest}</code>
      ) : null}
      <Button onClick={reset} variant="default">
        Try again
      </Button>
    </div>
  );
}
